/**
 * @flow
 * @relayHash 49a2e3db9685adbe314a398853db8e22
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UPSSettingsQueryVariables = {||};
export type UPSSettingsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +company: {|
      +id: string,
      +upsClientId: ?string,
      +upsClientSecret: ?string,
      +upsAccountNumber: ?string,
      +upsShipperName: ?string,
      +upsShipperPhone: ?string,
      +upsShipperAddressLine1: ?string,
      +upsShipperAddressLine2: ?string,
      +upsShipperAddressCity: ?string,
      +upsShipperAddressState: ?string,
      +upsShipperAddressZip: ?string,
      +upsShipperAddressCountry: ?string,
    |},
  |}
|};
export type UPSSettingsQuery = {|
  variables: UPSSettingsQueryVariables,
  response: UPSSettingsQueryResponse,
|};
*/


/*
query UPSSettingsQuery {
  viewer {
    id
    company {
      id
      upsClientId
      upsClientSecret
      upsAccountNumber
      upsShipperName
      upsShipperPhone
      upsShipperAddressLine1
      upsShipperAddressLine2
      upsShipperAddressCity
      upsShipperAddressState
      upsShipperAddressZip
      upsShipperAddressCountry
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsClientId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsClientSecret",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsAccountNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperPhone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressCity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressState",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressZip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressCountry",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UPSSettingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UPSSettingsQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "UPSSettingsQuery",
    "id": null,
    "text": "query UPSSettingsQuery {\n  viewer {\n    id\n    company {\n      id\n      upsClientId\n      upsClientSecret\n      upsAccountNumber\n      upsShipperName\n      upsShipperPhone\n      upsShipperAddressLine1\n      upsShipperAddressLine2\n      upsShipperAddressCity\n      upsShipperAddressState\n      upsShipperAddressZip\n      upsShipperAddressCountry\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b62ddb8ef7069ec898c45a2396f7d14a';
module.exports = node;
